import type { NandaDiagnoseKenmerk, NandaDiagnoseKenmerken } from '@/services';
import type { NnnKenmerkSectie, NnnKenmerkType } from '../types/careplan-nnn.types';
import { groupKenmerkenByCategorie } from './group-kenmerken-by-categorie';
import { kenmerkKey } from './kenmerk-key';

export interface BuildKenmerkSectiesOptions {
  selectableOnly?: boolean;
  keepKeys?: ReadonlySet<string>;
}

export const KENMERK_SECTIE_ORDER: readonly { type: NnnKenmerkType; titleKey: string }[] = [
  { type: 'BEPALEND_KENMERK', titleKey: 'defining-characteristics' },
  { type: 'SAMENHANGENDE_FACTOR', titleKey: 'related-factors' },
  { type: 'RISICO_FACTOR', titleKey: 'risk-factors' },
];

export function kenmerkenOfType(kenmerken: NandaDiagnoseKenmerken, type: NnnKenmerkType): NandaDiagnoseKenmerk[] {
  switch (type) {
    case 'BEPALEND_KENMERK':
      return kenmerken.bepalendeKenmerken;
    case 'SAMENHANGENDE_FACTOR':
      return kenmerken.samenhangendeFactoren;
    case 'RISICO_FACTOR':
      return kenmerken.risicoFactoren;
  }
}

export function buildKenmerkSecties(
  kenmerken: NandaDiagnoseKenmerken | null,
  options: BuildKenmerkSectiesOptions = {}
): NnnKenmerkSectie[] {
  return KENMERK_SECTIE_ORDER.map(({ type, titleKey }) => {
    const items = (kenmerken ? kenmerkenOfType(kenmerken, type) : []).filter(
      kenmerk => kenmerk.isActive !== false || isKept(type, kenmerk, options.keepKeys)
    );
    return {
      type,
      titleKey,
      groepen: groupKenmerkenByCategorie(options.selectableOnly ? items.filter(k => k.code !== null) : items),
    };
  });
}

function isKept(type: NnnKenmerkType, kenmerk: NandaDiagnoseKenmerk, keepKeys?: ReadonlySet<string>): boolean {
  return keepKeys !== undefined && kenmerk.code !== null && keepKeys.has(kenmerkKey(type, String(kenmerk.code)));
}
